// data/packages.js
export const internetPackages = [
  {
    id: 'basic-home',
    category: 'rumah',
    speed: '50 Mbps',
    name: 'Paket Internet Basic',
    description: 'Paket internet rumah untuk kebutuhan browsing, streaming, dan video call keluarga',
    price: 'Rp 299.000',
    originalPrice: 'Rp 399.000',
    discount: '25%',
    badge: 'HEMAT',
    badgeColor: 'bg-green-600',
    popular: false,
    features: [
      { name: 'Download 50 Mbps', icon: '⬇️' },
      { name: 'Upload 10 Mbps', icon: '⬆️' },
      { name: 'Unlimited Quota', icon: '∞' },
      { name: 'WiFi Router Gratis', icon: '📶' },
      { name: 'Instalasi Gratis', icon: '🔧' },
      { name: 'Support 24/7', icon: '💬' }
    ],
    specs: {
      'Download Speed': '50 Mbps',
      'Upload Speed': '10 Mbps',
      'Quota': 'Unlimited',
      'Router': 'WiFi 5 (802.11ac)',
      'Simultaneous Users': '15-20 devices',
      'Teknologi': 'Fiber Optic'
    },
    ideal: ['Rumah kecil', 'Keluarga 3-4 orang', 'Browsing & streaming', 'Work from home'],
    support: 'Customer Care 24/7',
    installation: 'Gratis instalasi'
  },
  {
    id: 'premium-home',
    category: 'rumah',
    speed: '100 Mbps',
    name: 'Paket Internet Premium',
    description: 'Paket internet rumah premium untuk streaming 4K, gaming, dan kebutuhan multimedia',
    price: 'Rp 449.000',
    originalPrice: 'Rp 599.000',
    discount: '25%',
    badge: 'POPULER',
    badgeColor: 'bg-purple-600',
    popular: true,
    features: [
      { name: 'Download 100 Mbps', icon: '⬇️' },
      { name: 'Upload 20 Mbps', icon: '⬆️' },
      { name: 'Unlimited Quota', icon: '∞' },
      { name: 'WiFi 6 Router', icon: '📶' },
      { name: 'Gaming Mode', icon: '🎮' },
      { name: 'Netflix Premium 3 Bulan', icon: '📺' },
      { name: 'Instalasi Gratis', icon: '🔧' },
      { name: 'Priority Support', icon: '⭐' }
    ],
    specs: {
      'Download Speed': '100 Mbps',
      'Upload Speed': '20 Mbps',
      'Quota': 'Unlimited',
      'Router': 'WiFi 6 (802.11ax)',
      'Simultaneous Users': '30-40 devices',
      'Teknologi': 'Fiber Optic FTTH'
    },
    ideal: ['Rumah menengah', 'Keluarga 4-6 orang', 'Gaming & streaming 4K', 'Smart home'],
    support: 'Priority Support 24/7',
    installation: 'Gratis instalasi + setup'
  },
  {
    id: 'gigabit-home',
    category: 'rumah',
    speed: '300 Mbps',
    name: 'Paket Internet Gigabit',
    description: 'Paket internet super cepat untuk kebutuhan maksimal rumah modern dan content creator',
    price: 'Rp 699.000',
    originalPrice: 'Rp 899.000',
    discount: '22%',
    badge: 'ULTIMATE',
    badgeColor: 'bg-gradient-to-r from-purple-600 to-pink-600',
    popular: false,
    features: [
      { name: 'Download 300 Mbps', icon: '⬇️' },
      { name: 'Upload 50 Mbps', icon: '⬆️' },
      { name: 'Unlimited Quota', icon: '∞' },
      { name: 'WiFi 6E Router', icon: '📶' },
      { name: 'Gaming Priority', icon: '🎮' },
      { name: 'Cloud Storage 1TB', icon: '☁️' },
      { name: 'Static IP Option', icon: '🌐' },
      { name: 'Netflix + Disney+ 6 Bulan', icon: '📺' },
      { name: 'VIP Support', icon: '👑' }
    ],
    specs: {
      'Download Speed': '300 Mbps',
      'Upload Speed': '50 Mbps',
      'Quota': 'Unlimited',
      'Router': 'WiFi 6E (802.11ax)',
      'Simultaneous Users': '50+ devices',
      'Teknologi': 'Dedicated Fiber FTTH'
    },
    ideal: ['Rumah besar', 'Content creator', 'Multiple streaming 4K/8K', 'Smart office'],
    support: 'VIP Dedicated Support',
    installation: 'Premium installation + optimization'
  },
  {
    id: 'business-internet',
    category: 'bisnis',
    speed: '200 Mbps',
    name: 'Paket Internet Bisnis',
    description: 'Solusi internet bisnis dengan SLA tinggi dan bandwidth dedicated untuk operasional kantor',
    price: 'Rp 1.299.000',
    originalPrice: 'Rp 1.699.000',
    discount: '24%',
    badge: 'BISNIS',
    badgeColor: 'bg-blue-600',
    popular: false,
    features: [
      { name: 'Download 200 Mbps', icon: '⬇️' },
      { name: 'Upload 100 Mbps', icon: '⬆️' },
      { name: 'Dedicated Bandwidth', icon: '🔒' },
      { name: 'Static IP Included', icon: '🌐' },
      { name: 'Business Router', icon: '📶' },
      { name: 'SLA 99.5%', icon: '📊' },
      { name: 'Email Hosting', icon: '📧' },
      { name: 'Business Support', icon: '💼' }
    ],
    specs: {
      'Download Speed': '200 Mbps',
      'Upload Speed': '100 Mbps',
      'Quota': 'Unlimited',
      'Router': 'Enterprise WiFi 6',
      'SLA': '99.5% uptime',
      'Teknologi': 'Dedicated Fiber'
    },
    ideal: ['Kantor kecil', 'Startup', 'Online business', 'Co-working space'],
    support: 'Business Support 24/7',
    installation: 'Professional business setup'
  },
  {
    id: 'enterprise-internet',
    category: 'perusahaan',
    speed: '1 Gbps',
    name: 'Paket Internet Enterprise',
    description: 'Koneksi internet enterprise grade dengan redundancy dan managed service',
    price: 'Rp 3.999.000',
    originalPrice: 'Rp 5.299.000',
    discount: '25%',
    badge: 'ENTERPRISE',
    badgeColor: 'bg-gray-800',
    popular: false,
    features: [
      { name: 'Download 1 Gbps', icon: '⬇️' },
      { name: 'Upload 500 Mbps', icon: '⬆️' },
      { name: 'Dedicated Line', icon: '🔒' },
      { name: 'Redundant Connection', icon: '🔄' },
      { name: 'Multiple Static IPs', icon: '🌐' },
      { name: 'SLA 99.9%', icon: '📊' },
      { name: 'Managed Firewall', icon: '🛡️' },
      { name: '24/7 NOC Monitoring', icon: '👁️' },
      { name: 'Dedicated Account Manager', icon: '👤' }
    ],
    specs: {
      'Download Speed': '1 Gbps',
      'Upload Speed': '500 Mbps',
      'Quota': 'Unlimited',
      'Router': 'Enterprise Grade',
      'SLA': '99.9% uptime',
      'Teknologi': 'Dedicated Metro Ethernet'
    },
    ideal: ['Perusahaan besar', 'Data center', 'ISP', 'Critical applications'],
    support: 'Enterprise NOC 24/7',
    installation: 'Enterprise deployment'
  }
];